<template>
  <!-- 可结算保单统计 -->
  <div class="main-container settleable-policy">
    <div class="info-wrap">
      <div class="sub-title">说明</div>
      <div class="content">1、本功能可用于查看平台保单下一个结算周期、满足结算条件的保单与预估结算服务费，以及其余不可结算保单的原因。</div>
      <div class="content">2、结算周期预计为每月18日，结算对象为上月期间承保的、以及以往承保且未结保单。</div>
      <div class="content">3、统计数据为截至今日0时满足结算条件或不满足结算条件的保单，最终结算与否，请以实际发放为准。</div>
    </div>
    <div class="satatistics">
      <img src="@/static/images/settlementManage/total-bg.png" alt="" />
      <div class="items">
        <div class="item">
          <span class="item-content">{{ totalData.balanceDate | filterTime('YYYY/MM/DD') }}</span>
          <span class="item-title">预计结算周期</span>
        </div>
        <div class="item">
          <span class="item-content">{{ totalData.incomesSum || 0 }}</span>
          <span class="item-title">预估可结算服务费(元)</span>
        </div>
        <div class="item">
          <span class="item-content">{{ totalData.policyNum || 0 }}</span>
          <span class="item-title">可结算保单(件)</span>
        </div>
        <div class="item">
          <span class="item-content">{{ totalData.unsettleablePolicyNum || 0 }}</span>
          <span class="item-title">不可结算保单(件)</span>
        </div>
      </div>
    </div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">保单号</span>
        <Input v-model="searchParams.policyNo" clearable placeholder="请输入" />
      </div>
      <div class="input-item">
        <span class="label">承保时间</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.dateTime"
          @on-change="searchParams.dateTime = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input v-model="searchParams.productName" clearable placeholder="请输入" />
      </div>
      <div class="input-item">
        <span class="label">保单状态</span>
        <Select v-model="searchParams.status" :transfer="true" clearable>
          <Option value="1">已承保</Option>
          <Option value="-1">已退保</Option>
          <Option value="2">已中止</Option>
          <Option value="0">已终止</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="reset()">查询</Button>
        <Button type="warning" @click="daochu" v-if="$units.pointAction('recruiting_2_2')">导出</Button>
      </div>
    </div>
    <div class="tab-wrap">
      <div class="tab" @click="reset('1')" :class="{ 'active': searchParams.type == 1 }">可结算保单</div>
      <div class="tab" @click="reset('2')" :class="{ 'active': searchParams.type == 2 }">不可结算保单</div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="status">
          <lzDicTxt dicType="POLICY_STATUS" :dicCode="row.status"></lzDicTxt>
        </template>
        <template slot-scope="{ row }" slot="holderName">
          {{ row.holderName }} <span v-if="row.insuranceName">/ {{ row.insuranceName }}</span>
        </template>
        <template slot-scope="{ row }" slot="reason">
          <div class="reason-wrap">
            <div class="reason-box" v-for="(item, idx) in row.unsettleableReasonList" :key="idx">
              <span class="reason">{{ ++idx }}.{{ item.reason || '-' }}</span>
              <span v-if="item.url || item.urlType == 3" @click="getUrl({ ...item, policyNo: row.policyNo })" :class="'btn-copy' + ' copy' + item.urlType"
                >复制链接</span
              >
            </div>
          </div>
        </template>
      </Table>
      <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>
  </div>
</template>
    
<script>
import { config } from './index.config.js';
import filters from '@/api/filter';
import lzDicTxt from '@/components/commons/lzDicTxt';
export default {
  mixins: [config],
  components: { lzDicTxt },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      listLoading: false,
      searchParams: {
        type: '1'
      },
      totalData: {},
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tableData: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    reset(val = null) {
      if (val) this.searchParams.type = val;
      this.pageNo = 1;
      this.tableData = [];
      this.getList();
    },
    daochu() {
      let params = JSON.parse(JSON.stringify(this.searchParams));
      if (params.dateTime && params.dateTime[0]) {
        params.insureTimeStart = filters.filterTime(params.dateTime[0], 'YYYY-MM-DD');
        params.insureTimeEnd = filters.filterTime(params.dateTime[1], 'YYYY-MM-DD');
        delete params.dateTime;
      }
      delete params.type;
      this.$units.downloadFile('/buz/policySettleable/exportData', params, 'PUT');
    },
    //获取链接
    async getUrl(row) {
      let url = '';
      if (row.urlType == 3) {
        let res = await this.$http({
          url: '/buz/policy/queryConfirmRightUrl',
          type: 'GET',
          data: {
            policyNo: row.policyNo
          }
        });
        console.log(res);
        url = res.data;
      } else {
        url = row.url;
      }
      console.log('url---', url);
      if (url) {
        const cInput = document.createElement('input');
        cInput.value = url;
        document.body.appendChild(cInput);
        cInput.select(); // 选取文本域内容;
        // 执行浏览器复制命令
        // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
        // Input要在正常的编辑状态下原生复制方法才会生效
        document.execCommand('Copy');
        this.$notice.success('获取成功');
        /// 复制成功后再将构造的标签 移除
        cInput.remove();
      } else {
        this.$notice.error('暂无链接可获取');
      }
    },
    // 订单列表
    getList(val) {
      this.getColumns();
      val ? (this.pageNo = val) : '';
      let params = JSON.parse(JSON.stringify(this.searchParams));
      if (params.dateTime && params.dateTime[0]) {
        params.insureTimeStart = filters.filterTime(params.dateTime[0], 'YYYY-MM-DD');
        params.insureTimeEnd = filters.filterTime(params.dateTime[1], 'YYYY-MM-DD');
      }
      delete params.dateTime;
      this.listLoading = true;
      this.$http({
        url: '/buz/policySettleable/queryData',
        type: 'PUT',
        data: {
          ...params,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.listLoading = false;
        this.total = res.data.data.total;
        this.tableData = res.data.data.records;
        this.totalData = res.data.settleableTotal;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  /deep/.ivu-table-cell {
    font-size: 14px !important;
  }
}
.settleable-policy {
  .info-wrap {
    width: 100%;
    height: 116px;
    background: #f5f5f5;
    border-radius: 4px;
    font-size: 12px;
    color: #727c8e;
    line-height: 17px;
    padding: 20px;
    margin-bottom: 20px;
    .sub-title {
      font-weight: 500;
      font-size: 14px;
      color: #515c6f;
      line-height: 20px;
      margin-bottom: 5px;
    }
  }
  .satatistics {
    height: 88px;
    margin: 20px 0px;
    border-radius: 10px;
    background: linear-gradient(106deg, #fff7ea 0%, #fff1e8 100%);
    display: flex;
    align-items: center;
    min-width: 1128px;
    img {
      height: 88px;
    }
    .items {
      display: flex;
      align-items: center;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 260px;
        &:not(:last-child) {
          border-right: 1px solid #e8d9c9;
        }
        .item-title {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 20px;
          color: #6a5041;
        }
        .item-content {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 600;
          line-height: 22px;
          color: #fc7700;
        }
      }
    }
    .back-btn {
      width: 80px;
      height: 32px;
      border-radius: 4px;
      background: #f47900;
      color: #fff;
    }
    .el-button {
      padding: 0;
    }
  }
  .tab-wrap {
    display: flex;
    margin-bottom: 15px;
    .tab {
      cursor: pointer;
      margin-right: 15px;
      width: 124px;
      height: 30px;
      background: #f3f3f3;
      border-radius: 4px;
      font-size: 13px;
      color: #515c6f;
      text-align: center;
      line-height: 30px;
    }
    .active {
      background: #236dff;
      color: #fff;
    }
  }
  .reason-wrap {
    text-align: left;
    .reason-box {
      display: flex;
      margin: 4px 0;
      .reason {
        flex: 1;
      }
      .btn-copy {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #236dff;
        cursor: pointer;
        // flex: 1;
        text-align: right;
        white-space: nowrap;
      }
      .disabled {
        cursor: none;
        color: #f3f3f3;
      }
    }
  }
}
</style>